import { useCallback, useEffect, useState } from 'react';
import api from '../../services/api';

export const useSubmissionDetail = (batchId) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDetail = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.get(`/odm-sftp/submissions/${encodeURIComponent(batchId)}`);
      setData(res.data);
    } catch (e) {
      setError(e.response?.data?.detail || 'Failed to load submission details');
    } finally {
      setLoading(false);
    }
  }, [batchId]);

  useEffect(() => {
    fetchDetail();
  }, [fetchDetail]);

  const updateNotifyEmails = (next) => {
    setData((prev) =>
      prev ? { ...prev, batch: { ...prev.batch, notify_emails: next } } : prev
    );
  };

  return { data, loading, error, updateNotifyEmails };
};
